import { useState } from 'react';
import { Play } from 'lucide-react';

export default function VideoFacade({ id, title }) {
  const [play, setPlay] = useState(false);
  return (
    <div
      className="relative aspect-video overflow-hidden border hairline bg-[#0b0b0b]"
      data-testid={`video-facade-${id}`}
    >
      {play ? (
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          data-testid={`video-play-${id}`}
          onClick={() => setPlay(true)}
          className="group absolute inset-0 h-full w-full text-left"
          aria-label={title}
        >
          <img
            src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
            alt=""
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-60 transition duration-500 group-hover:opacity-90 group-hover:scale-[1.03]"
          />
          <span className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
          <span className="absolute top-4 left-4 flex h-12 w-12 items-center justify-center rounded-full border border-[var(--pz-green)] text-[var(--pz-green)] transition group-hover:bg-[var(--pz-green)] group-hover:text-black">
            <Play size={18} fill="currentColor" />
          </span>
          <span className="absolute bottom-4 left-4 right-16 font-mono-label normal-case tracking-normal text-sm text-white/90 leading-snug">
            {title}
          </span>
        </button>
      )}
    </div>
  );
}
